import React from 'react'
import MaterialBox from '../../../../components/MaterialBox'
import MaterialTypography from '../../../../components/MaterialTypography'
import { IconButton } from '@mui/material'
import pdf from '../../../../assest/icons/pdf.png'
import doc from '../../../../assest/icons/office.png'

const AttachmentsCard = ({ attachments = [] }) => {
    const defaultAttachments = [
        {
            id: 1,
            name: 'Wireframe.doc',
            size: '300 KB',
            type: 'DOC',
            url: '#'
        },
        {
            id: 2,
            name: 'Development Brief.doc',
            size: '300 KB',
            type: 'PDF',
            url: '#'
        },
        {
            id: 3,
            name: 'Old Design.doc',
            size: '300 KB',
            type: 'FIG',
            url: '#'
        },
        {
            id: 4,
            name: 'Requirements.pdf',
            size: '450 KB',
            type: 'PDF',
            url: '#'
        },
        {
            id: 5,
            name: 'Mockup.fig',
            size: '1.2 MB',
            type: 'FIG',
            url: '#'
        },
        {
            id: 6,
            name: 'Specifications.doc',
            size: '250 KB',
            type: 'DOC',
            url: '#'
        }
    ];

    const files = attachments.length > 0 ? attachments : defaultAttachments;

    const getFileTypeIcon = (type) => {
        switch (type) {
            case 'DOC':
                return doc;
            case 'PDF':
                return pdf;
            case 'FIG':
                return doc;
            default:
                return doc;
        }
    };

    return (
        <MaterialBox sx={{
            border: '1px solid #ccd2d9',
            borderRadius: 3,
            padding: 1,
            height: "310px",
            display: 'flex',
            flexDirection: 'column'
        }}>
            <MaterialBox sx={{ display: 'flex', flexDirection: 'row', gap: 0.5, alignItems: 'center', mb: 2 }}>
                <MaterialBox sx={{ width: '6px', height: '12px', borderRadius: '30%', backgroundColor: '#5682e8' }} />
                <MaterialTypography variant='body2' fontWeight='bold' color='dark'>Attachments</MaterialTypography>
            </MaterialBox>

            <MaterialBox
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1.5,
                    flex: 1,
                    overflowY: 'auto',
                    '&::-webkit-scrollbar': {
                        display: 'none'
                    },
                    msOverflowStyle: 'none',
                    scrollbarWidth: 'none'
                }}
            >
                {files.map((file) => (
                    <MaterialBox
                        key={file.id}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            backgroundColor: '#f8f9fa',
                            borderRadius: 2,
                            padding: 1.5,
                            border: '1px solid #e9ecef',
                            '&:hover': {
                                backgroundColor: '#f1f3f5'
                            }
                        }}
                    >
                        <MaterialBox sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>

                            <MaterialBox
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                <img
                                    src={getFileTypeIcon(file.type)}
                                    alt={file.type}
                                    style={{ width: '30px', height: '30px', objectFit: 'contain' }}
                                />
                            </MaterialBox>


                            <MaterialBox sx={{ display: 'flex', flexDirection: 'column', gap: 0.2 }}>
                                <MaterialTypography
                                    variant='caption'
                                    fontWeight='bold'
                                    color='dark'
                                    sx={{ lineHeight: 1.3, fontSize: '0.875rem' }}
                                >
                                    {file.name}
                                </MaterialTypography>
                                <MaterialTypography
                                    variant='caption'
                                    sx={{ fontSize: '0.75rem', color: '#6c757d' }}
                                >
                                    {file.size}
                                </MaterialTypography>
                            </MaterialBox>
                        </MaterialBox>


                        <IconButton
                            size='small'
                            sx={{
                                bgcolor: 'transparent',
                                '&:hover': {
                                    bgcolor: '#e9ecef'
                                }
                            }}
                            onClick={() => window.open(file.url, '_blank')}
                        >
                            <svg width="22" height="20" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.4239 16.75C12.2079 16.75 12.0132 16.6587 11.8763 16.5126L7.26675 11.9059C6.97376 11.6131 6.97361 11.1382 7.26641 10.8452C7.55921 10.5523 8.03408 10.5521 8.32707 10.8449L11.6739 14.1896L11.6739 4C11.6739 3.58579 12.0096 3.25 12.4239 3.25C12.8381 3.25 13.1739 3.58579 13.1739 4L13.1739 14.1854L16.5168 10.8449C16.8098 10.5521 17.2846 10.5523 17.5774 10.8453C17.8702 11.1383 17.87 11.6131 17.5771 11.9059L13.0021 16.4776C12.8646 16.644 12.6566 16.75 12.4239 16.75Z" fill="#323544" />
                                <path d="M5.17188 16C5.17188 15.5858 4.83609 15.25 4.42188 15.25C4.00766 15.25 3.67188 15.5858 3.67188 16V18.5C3.67188 19.7426 4.67923 20.75 5.92188 20.75H18.9227C20.1654 20.75 21.1727 19.7426 21.1727 18.5V16C21.1727 15.5858 20.837 15.25 20.4227 15.25C20.0085 15.25 19.6727 15.5858 19.6727 16V18.5C19.6727 18.9142 19.337 19.25 18.9227 19.25H5.92188C5.50766 19.25 5.17188 18.9142 5.17188 18.5V16Z" fill="#323544" />
                            </svg>
                        </IconButton>
                    </MaterialBox>
                ))}
            </MaterialBox>
        </MaterialBox>
    )
}

export default AttachmentsCard